module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-5-d138952b.png";